import { render, staticRenderFns } from "./Boletos.vue?vue&type=template&id=1a976f09"
import script from "./Boletos.vue?vue&type=script&lang=js"
export * from "./Boletos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports